<div class="layout-col full" style="width: 50vw">
  <!-- Header Section -->
  <div class="layout-row">
    <mat-toolbar elderTheme class="gap-md">
      <button mat-icon-button (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>

      @if (settings.id) {
        <elder-header [header]="'jssp.update' | translate" [subheader]="settings.id">
        </elder-header>
      } @else {
        <elder-header [header]="'jssp.new' | translate"></elder-header>
      }
    </mat-toolbar>
  </div>

  <elder-single-pane-wrapper class="flex">
    <elder-pane-header>
      <elder-pane-actions>
        <button mat-icon-button name="save" [disabled]="!mainFrm.form.valid" (click)="onSave()">
          <mat-icon>save</mat-icon>
        </button>
      </elder-pane-actions>
    </elder-pane-header>

    <elder-pane-content>
      <form #mainFrm="ngForm" class="layout-col full">
        <div class="layout-row gap-xl">
          <div class="flex layout-col gap-lg">
            @if (settings.facility !== 'global') {
              <mat-form-field>
                <elder-select
                  appFacilitySelect
                  required
                  valueAsId="true"
                  [(ngModel)]="settings.facility"
                >
                </elder-select>
                <mat-label>{{ 'context.facility' | translate }}</mat-label>
                <mat-error elderValidationError></mat-error>
              </mat-form-field>
            }

            <mat-form-field>
              <input
                matInput
                name="maxPackageWeightKg"
                type="number"
                required
                min="0"
                [(ngModel)]="settings.maxPackageWeightKg"
              />
              <mat-label>{{ 'jssp.maxPackageWeight' | translate }}</mat-label>
              <mat-error elderValidationError></mat-error>
            </mat-form-field>

            <mat-form-field>
              <input
                matInput
                name="productionMinuteCost"
                type="number"
                required
                min="0"
                [(ngModel)]="settings.productionMinuteCost"
              />
              <mat-label>{{ 'jssp.productionMinuteCost' | translate }}</mat-label>
              <mat-error elderValidationError></mat-error>
              @if (showWarning(settings.productionMinuteCost, CostType.PRODUCTION_COST)) {
                <mat-icon
                  [matTooltip]="
                    getToolTip(settings.productionMinuteCost, CostType.PRODUCTION_COST) | translate
                  "
                  color="accent"
                  matSuffix
                >
                  warning
                </mat-icon>
              }
              @if (showWarning(settings.productionMinuteCost, CostType.PRODUCTION_COST)) {
                <mat-hint>
                  {{
                    getToolTip(settings.productionMinuteCost, CostType.PRODUCTION_COST) | translate
                  }}
                </mat-hint>
              }
            </mat-form-field>

            <mat-form-field>
              <input
                matInput
                name="involvedWcCost"
                type="number"
                required
                min="0"
                [(ngModel)]="settings.involvedWcCost"
              />
              <mat-label>{{ 'jssp.involvedWcCost' | translate }}</mat-label>
              <mat-error elderValidationError></mat-error>
              @if (showWarning(settings.involvedWcCost, CostType.WORK_CENTER_COST)) {
                <mat-icon
                  [matTooltip]="
                    getToolTip(settings.involvedWcCost, CostType.WORK_CENTER_COST) | translate
                  "
                  color="accent"
                  matSuffix
                >
                  warning
                </mat-icon>
              }
              @if (showWarning(settings.involvedWcCost, CostType.WORK_CENTER_COST)) {
                <mat-hint>
                  {{ getToolTip(settings.involvedWcCost, CostType.WORK_CENTER_COST) | translate }}
                </mat-hint>
              }
            </mat-form-field>

            <mat-form-field>
              <input
                matInput
                name="involvedPackageCost"
                type="number"
                required
                min="0"
                [(ngModel)]="settings.involvedPackageCost"
              />
              <mat-label>{{ 'jssp.involvedPackageCost' | translate }}</mat-label>
              <mat-error elderValidationError></mat-error>
              @if (showWarning(settings.involvedPackageCost, CostType.PACKAGE_COST)) {
                <mat-icon
                  [matTooltip]="
                    getToolTip(settings.involvedPackageCost, CostType.PACKAGE_COST) | translate
                  "
                  color="accent"
                  matSuffix
                >
                  warning
                </mat-icon>
              }
              @if (showWarning(settings.involvedPackageCost, CostType.PACKAGE_COST)) {
                <mat-hint>
                  {{ getToolTip(settings.involvedPackageCost, CostType.PACKAGE_COST) | translate }}
                </mat-hint>
              }
            </mat-form-field>

            <mat-form-field>
              <input
                matInput
                name="unequalDistributionCost"
                type="number"
                required
                min="0"
                [(ngModel)]="settings.unequalDistributionCost"
              />
              <mat-label>{{ 'jssp.unequalDistributionCost' | translate }}</mat-label>
              <mat-error elderValidationError></mat-error>
              @if (showWarning(settings.unequalDistributionCost, CostType.UNBALANCED_PENALTY)) {
                <mat-icon
                  [matTooltip]="
                    getToolTip(settings.unequalDistributionCost, CostType.UNBALANCED_PENALTY)
                      | translate
                  "
                  color="accent"
                  matSuffix
                >
                  warning
                </mat-icon>
              }
              @if (showWarning(settings.unequalDistributionCost, CostType.UNBALANCED_PENALTY)) {
                <mat-hint>
                  {{
                    getToolTip(settings.unequalDistributionCost, CostType.UNBALANCED_PENALTY)
                      | translate
                  }}
                </mat-hint>
              }
            </mat-form-field>
          </div>
        </div>
      </form>
    </elder-pane-content>
  </elder-single-pane-wrapper>
</div>
